/**
 * SearchInit
 *
 * Sistema di auto-inizializzazione per i blocchi di ricerca basato su configurazione JSON.
 * Legge le configurazioni da tag <script type="application/json"> e inizializza
 * le istanze della classe Search.
 *
 * Supporta:
 * - Multiple istanze di ricerca nella stessa pagina
 * - Configurazione dichiarativa JSON
 * - Endpoint centralizzati tramite AppConfig
 * - Isolamento tramite ID univoci
 */
const SearchInit = function() {

    let configCache = {};

    /**
     * Carica la configurazione JSON dal DOM
     * @param {string} configId - ID dello script di configurazione
     * @returns {Object|null} La configurazione parsata o null
     */
    function loadConfig(configId) {
        // Controlla cache
        if (configCache[configId]) {
            return configCache[configId];
        }

        const configElement = document.getElementById(configId);

        if (!configElement) {
            console.warn('[SearchInit] Config element not found:', configId);
            return null;
        }

        try {
            const config = JSON.parse(configElement.textContent);
            configCache[configId] = config;

            // Rimuovi l'elemento dal DOM per pulire l'HTML
            configElement.parentNode.removeChild(configElement);

            return config;
        } catch (error) {
            console.error('[SearchInit] Failed to parse configuration:', configId, error);
            return null;
        }
    }

    /**
     * Inizializza un'istanza di Search
     * @param {Object} config - Configurazione del blocco search
     * @returns {boolean} True se inizializzato con successo
     */
    function initSearchBlock(config) {
        // Verifica che la classe Search esista
        if (typeof Search === 'undefined') {
            console.error('[SearchInit] Search class is not defined');
            return false;
        }

        // Recupera gli endpoint da AppConfig
        const quickSearchEndpoint = AppConfig.getEndpoint('cart', 'quickSearch');
        const searchPageUrl = AppConfig.getEndpoint('cart', 'searchPage');

        if (!quickSearchEndpoint || !searchPageUrl) {
            console.error('[SearchInit] Search endpoints not found in AppConfig for block:', config.searchId);
            return false;
        }

        try {
            // Inizializza Search con la configurazione completa
            Search.init({
                'id': config.searchId,
                'endpoint': quickSearchEndpoint,
                'page': searchPageUrl,
                'input': config.inputSelector,
                'submit': config.submitSelector,
                'output': config.outputSelector
            });

            console.log('[SearchInit] Initialized search block:', config.searchId);
            return true;

        } catch (error) {
            console.error('[SearchInit] Error initializing search block:', config.searchId, error);
            return false;
        }
    }

    /**
     * Auto-inizializza tutti i blocchi di ricerca che hanno configurazione JSON
     */
    function autoInitialize() {
        $('script[id^="search-config-"]').each(function() {
            const configId = $(this).attr('id');
            const config = loadConfig(configId);

            if (config) {
                initSearchBlock(config);
            }
        });
    }

    /**
     * Resetta la cache (utile per testing)
     */
    function resetCache() {
        configCache = {};
    }

    // API pubblica
    return {
        /**
         * Inizializza un blocco di ricerca specifico
         * @param {string} configId - ID della configurazione
         */
        init: function(configId) {
            const config = loadConfig(configId);
            if (config) {
                return initSearchBlock(config);
            }
            return false;
        },

        /**
         * Auto-inizializza tutti i blocchi di ricerca
         */
        autoInit: function() {
            autoInitialize();
        },

        /**
         * Resetta la cache
         */
        reset: function() {
            resetCache();
        }
    };

}();

// Auto-inizializza quando il DOM è pronto
document.addEventListener('DOMContentLoaded', function() {
    SearchInit.autoInit();
});
